"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppSectionDefinition = void 0;
var react_1 = require("react");
var app_section_context_1 = require("../components/context/app-section-context");
/* Use the entity definition for the givne entity instance, or the current entity definition provided by context */
var useAppSectionDefinition = function () {
  return (0, react_1.useContext)(app_section_context_1.AppSectionContext);
};
exports.useAppSectionDefinition = useAppSectionDefinition;